import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface DepartmentsState {
  departments: any
  department: any
  error: any
}

export const useDepartmentsStore = defineStore('departments', {
  state: (): DepartmentsState => ({
    departments: null,
    department: null,
    error: null,
  }),

  getters: {
    getDepartments: (state) => state.departments,
    getDepartment: (state) => state.department,
    getError: (state) => state.error,
  },

  actions: {
    async fetchDepartments() {
      try {
        const response = await api().get('auth/api/departments')
        this.departments = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async createDepartment(data: any) {
      try {
        const response = await api().post('auth/api/departments/', data)
        this.department = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
